module.exports = {"371071004":"怡园街道","371071007":"田和街道","371071108":"初村镇","371071400":"双岛街道筹建处"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371071.json
// module id = 1445
// module chunks = 0